/**********************************************
 * Created by Kosterikov Pavel on 27.02.2019. *
 **********************************************/
import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap";
import { connect } from "react-redux";
import formatData from "@mnjsplatform/data/lib/utils/formatData";

class YardCard extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      fieldListSorted: null
    };
  }

  componentDidMount() {
    this.initFieldsListSorted();
  }

  componentDidUpdate(prevProps, prevState) {
    this.initFieldsListSorted();
  }

  initFieldsListSorted = () => {
    if(this.props.dataItem && this.props.dataItem.isInitialized
      && !this.props.dataItem.inOperation && this.state.fieldListSorted == null)
    {
      this.setState({fieldListSorted: this.sortFields(Object.assign([], this.props.dataItem.rawData.ResultFieldInfo))});
    }
  };

  sortFields(fieldsInfo){
    if(!fieldsInfo)
      return [];
    // сортировка в Google Chrome меняет порядок, если ViewNumber одинаков
    let allColumnsHaveSameViewOrder = true;
    let prevViewNumber;

    for (let i = 0; i < fieldsInfo.length; i++) {
      if (i === 0) {
        prevViewNumber = fieldsInfo[i].ViewNumber;
      }
      else if (prevViewNumber !== fieldsInfo[i].ViewNumber) {
        allColumnsHaveSameViewOrder = false;
        break;
      }
    }

    if (allColumnsHaveSameViewOrder) {
      return fieldsInfo;
    }
    else {
      return fieldsInfo.sort((a, b) => a.ViewNumber - b.ViewNumber);
    }
  }

  renderDataFields = (row) => {
    if(this.state.fieldListSorted == null)
      return null;

    return (
      <React.Fragment>
        {
          this.state.fieldListSorted.map((fieldInfo,fieldIndex)=>{

            if(fieldInfo.IsArtificial || fieldInfo.IsHidden || !fieldInfo.Title)
              return null;

            return (
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{fieldInfo.Title}</span>
                  <span>&nbsp;{formatData(fieldInfo, row[fieldInfo.Name])}</span>
                </div>
              </div>
            );
          })
        }
      </React.Fragment>
    );
  };

  render() {

    let row = this.props.dataItem.getRow(this.props.rowIndex);

    return (
      <div className="row col-md-4">
        <div className="col-md-12">
          <div className="card -cdoc mt20">
            <div className="card-header">
              <div className="row">
                <div className="col-md-5">
                  <h6>{row.SrcDocumentNumber}</h6>
                </div>
                <div className="col-md-7" style={{textAlign: "right"}}>
                  <h6 style={{color: "green"}}>{row.TruckStateName}</h6>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row fs15" style={{marginTop: "5px", marginBottom: "5px"}}>
                <div className="column col-md-12" style={{backgroundColor: "green"}}>
                  <span style={{color: "white"}}>{row.AutoNumber}</span>
                </div>
              </div>
              {this.renderDataFields(row)}
            </div>
          </div>
        </div>
      </div>
    );
    /*return (
      <main className="container-fluid cr-b-white"
            style={{paddingBottom: "15px",  boxShadow: "0 2px 3px 2px rgba(0,0,0,0.5)", width: "500px"}}>
        {result.map((e,i)=>{
          return <div key={i}>{e}</div>
        })}
      </main>
    );*/
  }
}

YardCard.propTypes = {
  // dispatch: PropTypes.func.isRequired
};


YardCard.defaultProps = {
  dataItem: PropTypes.object,
  rowIndex: PropTypes.number
};

function mapStateToProps(state, ownProps) {
  return {
  };
}

export default connect(mapStateToProps)(YardCard);